module.exports = __webpack_public_path__ + "img/494.66679305.jpg";